import { Checkbox } from "frontend/src/components/Checkbox/Checkbox";
import { useQuery } from "@apollo/client";
import CircularProgress from "@mui/material/CircularProgress";
import * as types from "_graphql-types/graphql";

import i18n from "i18next";

import {
  FETCH_IMPACT_CATEGORIES,
  ImpactFilterInput,
} from "Components/common/ImpactFilter";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import {
  removeFilter,
  updateFilter,
} from "Reducers/globalSearchV2/globalSearchV2.actions";
import { getInvestmentFilters } from "Reducers/globalSearchV2/globalSearchV2.selectors";
import { useDispatch } from "src/react-redux";
import { FilterInterface } from "../FilterInterface";

const defaultFilter: types.ImpactSearchFilter = { values: [], isOr: true };

function InvestmentImpactFilter(): JSX.Element {
  const investmentFilters = useSelector(getInvestmentFilters);

  const impactFilter: types.ImpactSearchFilter | null = useMemo(() => {
    const foundFilter = investmentFilters.find(
      filterI => filterI.type === "investment" && filterI.data.type === "IMPACT"
    );
    if (!foundFilter) return null;
    return foundFilter.data.data as types.ImpactSearchFilter;
  }, [investmentFilters]);

  const { loading, data, error } = useQuery<types.GetImpactCategoriesQuery>(
    FETCH_IMPACT_CATEGORIES
  );

  const [localFilter, setLocalFilter] = useState<types.ImpactSearchFilter>(
    impactFilter ?? defaultFilter
  );

  const dispatch = useDispatch();

  const setFilter = () => {
    if (localFilter) {
      dispatch(
        updateFilter({
          type: "investment",
          data: {
            type: "investment",
            data: {
              type: "IMPACT",
              data: localFilter,
            },
          },
        })
      );
    }
  };

  const reset = () => {
    setLocalFilter(defaultFilter);
    dispatch(
      removeFilter({
        type: "investment",
        data: {
          type: "investment",
          data: {
            type: "IMPACT",
            data: defaultFilter,
          },
        },
      })
    );
  };

  useEffect(() => {
    setLocalFilter(impactFilter ?? defaultFilter);
  }, [impactFilter]);

  return (
    <FilterInterface
      label={i18n.t("search_discovery.filters.labels.impact")}
      count={localFilter.values.length}
      reset={reset}
      set={setFilter}
      additionalControls={
        <Checkbox
          checked={!!localFilter.isOr}
          onChange={() =>
            setLocalFilter({
              ...localFilter,
              isOr: !localFilter.isOr,
            })
          }
        >
          Match on any selection. (or)
        </Checkbox>
      }
      menuClass="filters__menu-dropdown"
    >
      <div className="main-dropdown__menu-body">
        {loading && <CircularProgress size={20} />}
        {error && <span>Types failed to load</span>}
        {data && (
          <ImpactFilterInput
            availableImpactCategories={data}
            filter={localFilter}
            setFilter={setLocalFilter}
          />
        )}
      </div>
    </FilterInterface>
  );
}

export default InvestmentImpactFilter;
